import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Radio from '@material-ui/core/Radio';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import { ImageComponent } from '../../components/quizzing/ImageComponent';
import { AppHelper } from '../../helpers/AppHelper';


export class MultiTextComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  change = e => {
    this.setState({
      value: e.target.value
    });
    if(this.props.data.otherAllowed === 'YES' && this.props.otherAllowedMode) {
      this.props.handleState(AppHelper.getOtherValuePrefix() + e.target.name, e.target.value)
    } else {
      this.props.handleState(e.target.name, e.target.value)
    }
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle && !this.props.otherAllowedMode &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
          {this.props.data.otherAllowed === 'YES' && this.props.otherAllowedMode &&
            <p className={css(Styles.otherLabel)}>{'Other, please explain'}</p>
          }
        </div>
        {this.props.data.image && !this.props.otherAllowedMode &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <TextField
            name={this.props.data.id}
            value={this.state.value}
            placeholder={'Enter text'}
            onChange={e => this.change(e)}
            disabled={this.props.disabled}
            margin='normal'
            className={this.props.disabled ? css(CommonStyles.textFieldDisabled, Styles.textField) : css(CommonStyles.textField, Styles.textField)}
            multiline
            rows={this.props.rows}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.props.disabled ? css(CommonStyles.textFieldContentInputDisabled) : css(CommonStyles.textFieldContentInput)
              }
            }}
          />
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  textField: {
    maxHeight: 'unset'
  },
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    width: '35%',
    '@media (max-width: 767px)': {
      marginLeft: 10,
      width: '96%'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      width: '45%',
    },
  },
  otherLabel: {
    marginLeft: 20,
    fontSize: AppTheme.subTitleSize,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/MultiTextComponent.js